import { PeerMessage, PeerMessageType } from '@playcastdotio/Messaging';
import { playerConnectionState } from '../../../stores/playerStores';
import { getPeer } from '../../peer';
import { joinState } from '../../../stores/globalStores';

export const handlePeerMessage = (message: PeerMessage) => {
  switch (message.type) {
    case PeerMessageType.PEER_GET_ID_ANSWER: {
      playerConnectionState.updateState({
        ...playerConnectionState.currentState,
        playerPeerId: message.peerId,
        iceServers: message.iceServers || undefined,
      });
      break;
    }
    case PeerMessageType.PEER_ICE_CANDIDATE:
    case PeerMessageType.PEER_SDP_ANSWER:
    case PeerMessageType.PEER_SDP_OFFER: {
      const peer = getPeer();
      if (peer) {
        peer.handlePeerMessage(message);
      }
      break;
    }
    case PeerMessageType.PEER_ERROR: {
      console.error('Peer error', message);
      // If we're currently connecting and get a peer error, show error state
      if (joinState.currentState.state === 'connecting') {
        joinState.updateState({
          ...joinState.currentState,
          state: 'error',
        });
      }
      break;
    }
  }
};
